import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M17.7 9.4.9 27.8v-6.7L16 4.2 31.1 21v6.7L14.3 9.4h3.4zm0 0L.9 27.8v-6.7L16 4.2 31.1 21v6.7L14.3 9.4h3.4z"
      stroke="none"
    />
  </svg>
)

export default SvgGelIconChevronUp
